





















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class CircularProgress extends Vue {
	// Circle progress bar component with the ability to be paused and played on click.
	// Toggle must be managed by parent component. See EscalatedAlertTableTab for example usage.

	@Prop({ required: true, type: Number })
	public readonly maxTime!: number;

	@Prop({ type: String })
	public readonly tooltip?: string;

	public timer: number = 0;
	public interval: number = 0;

	public get circumference(): number {
		return 2 * Math.PI * 15.9155;
	}

	// Is called every 0.1 seconds from an interval created on component mount.
	// Reloads escalated alerts when timer reaches limit
	public updateTimer() {
		if (this.timer >= this.maxTime) {
			this.timer = 0;
			this.handleReload();
		} else {
			this.timer++;
		}
	}

	public async mounted() {
		this.interval = setInterval(this.updateTimer, 1000);
	}

	@Emit('reload')
	public handleReload() {}
}
